import React, { SetStateAction, Dispatch } from "react";

interface PreviewExamProps {
    showAnswer: boolean;
    setShowAnswer: Dispatch<SetStateAction<boolean>>;
}
export const previewExamContext = React.createContext<PreviewExamProps>({
    showAnswer: false,
    setShowAnswer: () => null
});
